import ListagemFretesController from './listagem-fretes.controller';

export default (ngModule) => {
  ngModule
    .directive('listagemFretes', function listagemFretes() {
      return {
        restrict: 'E',
        scope: {
          filtro: '=',
          index: '=',
          scrollContainerId: '@'
        },
        controller: ListagemFretesController,
        template: require('./listagem-fretes.html'),
        controllerAs: 'vm',
        bindToController: true
      };
    });
};



/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./pages/consulta/common/components/listagem-fretes/listagem-fretes.directive.ts
 **/